import { connect } from 'react-redux';
import { compose, map, path, pipe, replace, pathOr, applySpec } from 'ramda';

import OrganizationsTable from 'components/Organizations/Table';
import withPageLoader from 'components/withPageLoader';

import {
  getOrganizationsShouldShowLoading,
  getOrganizationsEntry,
} from 'store/selectors/organizations';
import { requestOrganizations } from 'store/actionCreators/organizations';

const mapStateToProps = state => {
  const entry = getOrganizationsEntry(state);

  return {
    data: map(
      applySpec({
        name: path(['resource', 'name']),
        id: path(['resource', 'id']),
        practitioners: pipe(
          pathOr([], ['resource', 'participant']),
          map(practitioner => {
            const role = path(['member', 'identifier', 'value'], practitioner);
            const name = path(['member', 'display'], practitioner);
            const id = pipe(
              path(['member', 'reference']),
              replace('Practitioner/', ''),
            )(practitioner);

            return `${role}: ${name}(${id})`;
          }),
        ),
      }),
      entry,
    ),
  };
};

export default compose(
  withPageLoader({
    loadingSelector: getOrganizationsShouldShowLoading,
    initialAction: requestOrganizations,
  }),
  connect(mapStateToProps),
)(OrganizationsTable);
